import React, { useState, useEffect, useRef } from "react";
import { fieldDependencies, invisiblestring } from "./globalVariables";

export default function MySelect({
   basicdata,
   onOffice,
   fieldconfiguration,
   data,
   userList,
   isPublished,
   changeData,
   value,
   multiselect,
}) {
   const [show, setShow] = useState(false);
   const optionsRef = useRef(null);

   useEffect(() => {
      function handleClickOutside(event) {
         if (optionsRef.current && !optionsRef.current.contains(event.target)) {
            console.log("Außerhalb geklickt!");
            setShow(false);
         }
      }
      function handleWindowBlur() {
         // setShow(false);
      }
      // Den Listener hinzufügen
      document.addEventListener("mousedown", handleClickOutside);
      window.addEventListener("blur", handleWindowBlur);

      // WICHTIG: Den Listener beim Unmount entfernen (Cleanup)
      return () => {
         document.removeEventListener("mousedown", handleClickOutside);
         window.removeEventListener("blur", handleWindowBlur);
      };
   }, []);

   return (
      <>
         {data && (
            <div className="myselect mb-2 mt-2">
               {isPublished && (
                  <div
                     style={{
                        backgroundColor: "#e00",
                        color: "#fff",
                        padding: "4px 10px",
                        marginBottom: "10px",
                     }}
                  >
                     Achtung! Diese Daten sind veröffentlicht! Sind Änderungen mit Grafik usw. abgesprochen?
                  </div>
               )}
               <label className="form-label">{data.heading}</label>
               {value[0] === invisiblestring ? (
                  <input
                     value={value}
                     onChange={(e) => {
                        changeData(data.name, e.target.value, "single");
                     }}
                     className={(value || data.optional ? "" : "empty-field ") + "form-control mb-2 mt-2"}
                  />
               ) : (
                  <>
                     <button
                        className={
                           ((!(Array.isArray(value) && value.length <= 0) && value) || data.optional
                              ? ""
                              : "empty-field ") + "form-control mb-2 mt-0"
                        }
                        onClick={(e) => {
                           console.log(data);
                           console.log(value);
                           console.log(fieldconfiguration);

                           e.preventDefault();
                           setShow(true);
                        }}
                        disabled={data.readOnly}
                     >
                        {fieldconfiguration ? (
                           <span className="ms-1">
                              {Array.isArray(value)
                                 ? value.map((item) => fieldconfiguration.permittedvalues[item]).join(", ")
                                 : fieldconfiguration.permittedvalues[value]}
                           </span>
                        ) : (
                           <span className="ms-1">
                              {Array.isArray(value)
                                 ? value.map((item) => (data.optionObject ? data.optionObject[item] : item)).join(", ")
                                 : data.optionObject
                                   ? data.optionObject[value]
                                   : value}
                           </span>
                        )}
                     </button>
                     {show && (
                        <ul ref={optionsRef} style={{ maxHeight: "300px", overflow: "auto" }}>
                           {!(onOffice || multiselect === "multi") && (
                              <li
                                 className="myselect-option"
                                 onClick={() => {
                                    changeData(data.name, "", "single");

                                    setShow(false);
                                 }}
                                 key={"initselect_"}
                              >
                                 {invisiblestring}
                              </li>
                           )}

                           {!fieldconfiguration &&
                              data.options &&
                              data.options.map((option, index) => (
                                 <li
                                    className="myselect-option"
                                    style={value.includes(option) ? { background: "#333", color: "#fff" } : {}}
                                    onClick={() => {
                                       changeData(
                                          data.name,
                                          option === (!onOffice && "Sonstiges") ? invisiblestring : option,
                                          multiselect ? "multi" : "single",
                                       );
                                       if (!multiselect) {
                                          setShow(false);
                                       }
                                    }}
                                    key={"select_" + option}
                                 >
                                    {data.optionNames ? data.optionNames[index] : option}
                                 </li>
                              ))}
                           {data.optionObject &&
                              Object.keys(data.optionObject)
                                 .sort((a, b) => (data.optionObject[a] > data.optionObject[b] ? 1 : -1))
                                 .map((option) => {
                                    let myvVal = data.optionObject[option];

                                    if (myvVal)
                                       return (
                                          <li
                                             className="myselect-option"
                                             style={value.includes(option) ? { background: "#333", color: "#fff" } : {}}
                                             onClick={() => {
                                                changeData(
                                                   data.name,
                                                   option === (!onOffice && "Sonstiges") ? invisiblestring : option,
                                                   multiselect ? "multi" : "single",
                                                );
                                                if (!multiselect) {
                                                   setShow(false);
                                                }
                                             }}
                                             key={"select_" + option}
                                          >
                                             {myvVal}
                                          </li>
                                       );
                                 })}
                           {fieldconfiguration &&
                              Object.keys(fieldconfiguration.permittedvalues).map((option) => {
                                 let myvVal = false;

                                 if (fieldDependencies?.[data.module]?.[data.name]) {
                                    console.log(basicdata[fieldDependencies[data.module][data.name]]);

                                    if (
                                       fieldconfiguration.dependencies[option] ===
                                       basicdata[fieldDependencies[data.module][data.name]]
                                    ) {
                                       myvVal = fieldconfiguration.permittedvalues[option];
                                    }
                                 } else {
                                    myvVal = fieldconfiguration.permittedvalues[option];
                                 }

                                 if (myvVal)
                                    return (
                                       <li
                                          className="myselect-option"
                                          style={value.includes(option) ? { background: "#333", color: "#fff" } : {}}
                                          onClick={() => {
                                             changeData(
                                                data.name,
                                                option === (!onOffice && "Sonstiges") ? invisiblestring : option,
                                                multiselect ? "multi" : "single",
                                             );
                                             if (!multiselect) {
                                                setShow(false);
                                             }
                                          }}
                                          key={"select_" + option}
                                       >
                                          {myvVal}
                                       </li>
                                    );
                              })}
                        </ul>
                     )}
                  </>
               )}
            </div>
         )}
      </>
   );
}
